import TkHelpIcon from "../../components/atoms/TkHelpIcon";

/**
 * フォームの情報(Title)
 */
const staffInfoHeadTitleList: any[] = [
  {
    headTitle: (
      <>
        氏名
        <TkHelpIcon
          helpMessage={
            <>
              登録されている被共済職員の氏名です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字を使用されている場合は、正しく表示されていない恐れがあります。
              表示されていない場合は、常用漢字を用いて入力をお願いします。
              <br />
              なお、外国人については、フリガナ、漢字欄ともに「カタカナ」で入力をしてください。
            </>
          }
        />
        <br />
        生年月日
        <TkHelpIcon helpMessage="被共済職員の生年月日です。" />
        <br />
        性別
      </>
    ),
  },
  {
    headTitle: (
      <>
        加入日
        <br />
        加入資格
        <TkHelpIcon
          helpMessage={
            <>
              加入資格については、{" "}
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫加入要件について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
        <br />
        職種
        <TkHelpIcon
          helpMessage={
            <>
              被共済職員の職種です。詳しくは、{" "}
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫職種について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        在籍期間
        <TkHelpIcon
          helpMessage={
            <>
              4月1日から7月31日までは加入日から前々年度３月末までの期間です。
              <br />
              8月1日から3月31日までは加入日から前年度３月末までの期間です。
              <br />
              なお、在籍期間には不算入期間（「ならない月」及び「育休期間」の1/2）は含みますが、契約対象外施設等に在籍していた期間は共済法上は制度上の退職にあたるため除かれています。
            </>
          }
        />
        <br />
        有効期間
        <TkHelpIcon
          helpMessage={
            <>
              在籍期間から不算入期間（「ならない月」及び「育休期間」の1/2）を除いた期間です。有効期間が退職手当金の算定基礎となります。
              <br />
              ※表示されている有効期間は前々年度３月末までの期間です。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        4/1の俸給表の額
        <TkHelpIcon
          helpMessage={
            <>
              　給与規程の俸給表に格付けされた俸給の額です。
              <br />
              　ただし、給与規程で本俸が定められていない職員は、雇用契約書で定める労働条件をもとに計算した額となります。
            </>
          }
        />
        <br />
        俸給の調整額
        <TkHelpIcon
          helpMessage={
            <>
              　本制度において、退職手当金の計算の基礎額に算入する、特別な手当をいいます
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: "異動内容",
  },
  {
    headTitle: "ならない月",
    helpText: (
      <>
        前年度における「ならない月」です。詳しくは
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫「なる月」「ならない月」について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    headTitle: "育休",
    helpText: (
      <>
        育児休業については、{" "}
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫育児休業について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    headTitle: "他共済",
    helpText:
      "当機構の共済制度とは別に都道府県の共済制度に加入している場合は「○」と表示されます。",
  },
];

export { staffInfoHeadTitleList };
